module.exports = __webpack_public_path__ + "img/categorie-quisommesnous-famille-boutrais.54935cf6.jpg";